import repository from '../../repositories/request/request.return.repository'

const returnToNotStarted = async (requestId) =>
    repository.returnToNotStarted(requestId);

export default {
    returnToNotStarted,
}
